// Breakpoints match tailwind.config.js screens (sm / md / lg).
export const SIDE_BY_SIDE_FROM = {
    MOBILE: 'mobile',
    TABLET: 'tablet',
    DESKTOP: 'desktop',
    // Saved value 'always' = UI "Never" (never stack)
    ALWAYS: 'always',
}

export const SIDE_BY_SIDE_BREAKPOINTS = {
    [SIDE_BY_SIDE_FROM.MOBILE]: 576, // sm
    [SIDE_BY_SIDE_FROM.TABLET]: 768, // md
    [SIDE_BY_SIDE_FROM.DESKTOP]: 992, // lg
}

export const SIDE_BY_SIDE_FROM_OPTIONS = [
    {
        label: `below Mobile (${SIDE_BY_SIDE_BREAKPOINTS[SIDE_BY_SIDE_FROM.MOBILE]}px)`,
        value: SIDE_BY_SIDE_FROM.MOBILE,
    },
    {
        label: `below Tablet (${SIDE_BY_SIDE_BREAKPOINTS[SIDE_BY_SIDE_FROM.TABLET]}px)`,
        value: SIDE_BY_SIDE_FROM.TABLET,
    },
    {
        label: `below Desktop (${SIDE_BY_SIDE_BREAKPOINTS[SIDE_BY_SIDE_FROM.DESKTOP]}px)`,
        value: SIDE_BY_SIDE_FROM.DESKTOP,
    },
    { label: 'Never', value: SIDE_BY_SIDE_FROM.ALWAYS },
]

/**
 * Resolves stack-in-column breakpoint, with fallback for legacy mobileTwoColumnLayout.
 * Values: mobile (sm/576), tablet (md/768), desktop (lg/992), always (never stack).
 */
export const resolveSideBySideFrom = ({ sideBySideFrom, mobileTwoColumnLayout } = {}) => {
    if (sideBySideFrom) {
        return sideBySideFrom
    }

    if (mobileTwoColumnLayout) {
        return SIDE_BY_SIDE_FROM.ALWAYS
    }

    return SIDE_BY_SIDE_FROM.TABLET
}
